import FormBaseModel from '@cp-models/FormBaseModel';

const TYPE_READABLE = {
    'reseller': 'Revendedor',
    'partner': 'Parceiro',
    'whitelabel': 'Whitelabel'
}
const TYPE_COLOR = {
    'reseller': 'purple lighten-3',
    'partner': 'purple darken-3',
    'whitelabel': 'purple accent-3'
}
const TYPE_TEXT_COLOR = {
    'reseller': 'black',
    'partner': 'white',
    'whitelabel': 'white'
}

export default class Reseller extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'trade_name': 'string',
            'type': 'string',
            'payment_gateway_id': 'number',
            'deleted_at': 'any',
        }
    }

    get deletedAt()
    {
        return this.formatDate(this.deleted_at)
    }

    get typeReadable()
    {
        return TYPE_READABLE[this.type]
    }

    get typeColor()
    {
        return TYPE_COLOR[this.type]
    }

    get typeTextColor()
    {
        return TYPE_TEXT_COLOR[this.type]
    }

}
